export const name = 'rnSingSession';

export default function rnSingSession($log) {
  //noinspection BadExpressionStatementJS
  'ngInject';
  var self = this;

  self.authenticated = undefined;

  var service = {
    id: undefined,
    user: {},
    context: {},
    isAuthenticated: isAuthenticated,
    _create: _create,
    _destroy: _destroy
  };

  return service;


  function isAuthenticated() {
    return self.authenticated;
  }


  function _create(sessionId, user, context) {
    $log.debug('rnSingSession#create');
    service.id = sessionId;
    service.user = angular.copy(user);
    service.context = angular.copy(context);
    self.authenticated = true;
  }


  function _destroy() {
    $log.debug('rnSingSession#destroy');
    service.id = null;
    service.user = {};
    service.context = {};
    self.authenticated = false;
  }
} //rnSingSession
